import React from "react";
import PropTypes from "prop-types";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
	Form,
	FormGroup,
	Col,
	Input,
	FormFeedback,
	Label,
	Button,
} from "reactstrap";
import { Modal, ModalBody } from "reactstrap";
import ataDefinitionTagService from "services/AtaDefinitionTagService";
import { FloppyDisk, SignOut } from "@phosphor-icons/react";

const ExcludeDefinitionModal = ({ show, onCloseClick, data }) => {
	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {
			tag: "",
			ata_definitions_id: data,
			active: 1,
		},

		validationSchema: Yup.object({
			tag: Yup.string().required("Por favor, informe nome da tag"),
		}),
		onSubmit: async (values) => {
			await ataDefinitionTagService.post(values);
			onCloseClick();
		},
	});

	return (
		<Modal
			size="sm"
			isOpen={show}
			toggle={onCloseClick}
			centered={true}
			style={{ minWidth: 100 }}
		>
			<div className="modal-content">
				<ModalBody className="px-4 py-5 text-center">
					<Col md="12">
						<Form
							className="needs-validation"
							onSubmit={(e) => {
								e.preventDefault();
								validation.handleSubmit();
								return false;
							}}
						>
							<FormGroup className="mb-3">
								<Label htmlFor="definition">
									Tag <span style={{ color: "red" }}>*</span>
								</Label>
								<Input
									name="tag"
									type="text"
									placeholder="Nome da tag"
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.tag || ""}
									invalid={validation.errors.tag}
								/>
								{validation.touched.tag &&
								validation.errors.tag ? (
									<FormFeedback type="invalid">
										{validation.errors.tag}
									</FormFeedback>
								) : null}
							</FormGroup>
							<div className="hstack gap-2 justify-content-center mb-0">
								<Button
									type="submit"
									style={{
										background: "none",
										padding: 10,
										cursor: "pointer",
										color: "black",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										gap: 2,
									}}
								>
									<FloppyDisk size={16} /> Salvar
								</Button>
								<Button
									type="button"
									style={{
										background: "none",
										padding: 10,
										cursor: "pointer",
										color: "black",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										gap: 2,
									}}
									onClick={onCloseClick}
								>
									<SignOut size={16} /> Fechar
								</Button>
							</div>
						</Form>
					</Col>
				</ModalBody>
			</div>
		</Modal>
	);
};

ExcludeDefinitionModal.propTypes = {
	show: PropTypes.bool,
};

export default ExcludeDefinitionModal;
